import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoreVertical = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M10 16a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Zm0-6.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Zm0-6.75a.75.75 0 1 1-.75.75l.004-.077a.75.75 0 0 1 .669-.67L10 2.5Z"
	})]
});
const ForwardRef = forwardRef(SvgMoreVertical);
export { ForwardRef as ReactComponent };
